import React, { Component } from 'react';
import '../APIResReqStyle.css';
import useAPIResReqStore from '../useAPIResReqStore';
import { validURL } from '../../../utils/CanvasUtil';
import ConfigurationModeSelector from './ConfigurationModeSelector';
import ManualSetup from './ManualSetup';
import CurlSetup from './CurlSetup';

class SetUpRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      boolState: false,
      placeholders: [],
      headerErrors: false,
      errors: false,
      headerErrorMessage: '',
      errorMessage: '',
      updateState: false,
      focus: null,
    };

    if (
      (this.props.isNewComponent || this.isManualModeInDefaultState()) &&
      useAPIResReqStore.getState().requestData.setupMode === 'MANUAL'
    ) {
      useAPIResReqStore.getState().setSetupRequestMode('CURL');
      useAPIResReqStore.getState().setSetupSampleMode('CURL');
    }
  }

  isManualModeInDefaultState = () => {
    const { requestData } = useAPIResReqStore.getState();

    const isDefaultBody = !requestData.body || requestData.body.trim() === '';

    const isDefaultMethod = requestData.request_type === 'POST';
    const isDefaultDataType = requestData.data_type === 'JSON';

    const isDefaultEndpoint = !requestData.endpoint_url || requestData.endpoint_url.trim() === '';

    const noCustomHeaders = !requestData.headers || requestData.headers.length === 0;

    return (
      isDefaultBody && isDefaultMethod && isDefaultDataType && isDefaultEndpoint && noCustomHeaders
    );
  };

  componentDidMount() {
    this.validateRequest();
  }

  forceUpdateState = () => {
    let currentState = this.state.updateState;
    this.setState({ updateState: !currentState });
  };

  validateRequest = isNavigating => {
    this.setState({ headerErrors: false, headerErrorMessage: '', errors: false, errorMessage: '' });

    if (
      useAPIResReqStore.getState().requestData &&
      useAPIResReqStore.getState().requestData.headers &&
      useAPIResReqStore.getState().requestData.headers.length > 0
    ) {
      useAPIResReqStore.getState().requestData.headers.forEach(h => {
        if (h.header_name == '' || h.header_value == '') {
          this.setState({
            headerErrors: true,
            headerErrorMessage: 'Headers cannot be empty.',
          });
        }
      });
    }

    let hasPlaceholder = false;
    const { availablePlaceholders } = this.props;
    availablePlaceholders.forEach(availablePlaceholder => {
      availablePlaceholder.placeholders.forEach(placeholder => {
        if (
          useAPIResReqStore.getState().requestData &&
          useAPIResReqStore.getState().requestData.endpoint_url &&
          useAPIResReqStore.getState().requestData.endpoint_url.includes(placeholder.key)
        ) {
          hasPlaceholder = true;
        }
      });
    });
    if (hasPlaceholder) {
      this.setState({ errors: false, errorMessage: '' });

      (isNavigating || this.props.initialLoad) &&
        this.props.onChangeState &&
        this.props.onChangeState(1, 1);
      this.props.setInitialLoad && this.props.setInitialLoad(false);
    } else {
      if (validURL(useAPIResReqStore.getState().requestData.endpoint_url)) {
        this.setState({ errors: false, errorMessage: '' });
        (isNavigating || this.props.initialLoad) &&
          this.props.onChangeState &&
          this.props.onChangeState(1, 1);
        this.props.setInitialLoad && this.props.setInitialLoad(false);
      } else {
        this.setState({
          errors: true,
          errorMessage: 'Invalid or empty endpoint URL',
        });
      }
    }
  };

  handleCurl = () => {
    this.setState({ errors: false, errorMessage: '' });
    this.props.onChangeState && this.props.onChangeState(1, 1);
  };

  handleModeChange = mode => {
    if ((this.props.isNewComponent || this.isManualModeInDefaultState()) && mode === 'MANUAL') {
      return;
    }

    useAPIResReqStore.getState().setSetupRequestMode(mode);
    useAPIResReqStore.getState().setSetupSampleMode(mode);
    this.forceUpdateState();
  };

  setOnFocus = focus => {
    this.setState({ focus });
    if (this.props.setOnFocus) {
      this.props.setOnFocus(focus);
    }
  };

  render() {
    const { headerErrors } = this.state;
    const { availablePlaceholders, keyPlaceholders, valuePlaceholders, isNewComponent } =
      this.props;

    const shouldHideManualOption = isNewComponent || this.isManualModeInDefaultState();

    return (
      <div>
        <ConfigurationModeSelector
          onModeChange={this.handleModeChange}
          hideManualOption={shouldHideManualOption}
        />

        {useAPIResReqStore.getState().requestData.setupMode === 'MANUAL' && (
          <ManualSetup
            availablePlaceholders={availablePlaceholders}
            keyPlaceholders={keyPlaceholders}
            valuePlaceholders={valuePlaceholders}
            validateRequest={this.validateRequest}
            setOnFocus={this.setOnFocus}
            headerErrors={headerErrors}
          />
        )}

        {useAPIResReqStore.getState().requestData.setupMode === 'CURL' && (
          <CurlSetup
            setOnFocus={this.setOnFocus}
            handleCurl={this.handleCurl}
            onChangeState={this.props.onChangeState}
          />
        )}
      </div>
    );
  }
}

SetUpRequest.defaultProps = {
  isNewComponent: false,
};

export default SetUpRequest;
